export const RU = {
  "Open document": "ÐÑÐºÑÑÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ",
  "Upload file": "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ°Ð¹Ð»",
  "Drop file here to upload": "ÐÐµÑÐµÑÐ°ÑÐ¸ÑÐµ ÑÐ°Ð¹Ð» ÑÑÐ´Ð°, ÑÑÐ¾Ð±Ñ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ",
  "Disc": "ÐÐ¸ÑÐº",
  "URL": "URL",
  "FILE": "Ð¤ÐÐÐ",
  "SIZE": "Ð ÐÐÐÐÐ ",
  "MB": "ÐÐ",
  "KB": "ÐÐ",
  "Bytes": "ÐÐ°Ð¹ÑÐ¾Ð²",
  "Loading... Please wait.": "ÐÐ°Ð³ÑÑÐ·ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ° Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ.",
  "Fit Width": "ÐÐ¾ ÑÐ¸ÑÐ¸Ð½Ðµ",
  "Fit Height": "ÐÐ¾ Ð²ÑÑÐ¾ÑÐµ",
  "Password protected document": "ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ, Ð·Ð°ÑÐ¸ÑÐµÐ½Ð½ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»ÐµÐ¼",
  "Password": "ÐÐ°ÑÐ¾Ð»Ñ",
  "Open": "ÐÑÐºÑÑÑÑÐ¼",
  "Password Required": "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¿Ð°ÑÐ¾Ð»Ñ",
  "Incorrect password": "ÐÐµÐ²ÐµÑÐ½ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ",
  "Error": "ÐÑÐ¸Ð±ÐºÐ°",
  "Something went wrong": "Ð§ÑÐ¾-ÑÐ¾ Ð¿Ð¾ÑÐ»Ð¾ Ð½Ðµ ÑÐ°Ðº",
  "Server is not available": "Ð¡ÐµÑÐ²ÐµÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
  "of": "Ð¸Ð·",
  "Please wait...": "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°..."
};
